import {MMQueryOptions} from 'lionheartland';


export class SODeleteProduct {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
